// Affichage des données personnelles clients côté flow.
//
// L'api masque déjà ce qu'elle renvoie (`view_customer_pii`) : ces helpers
// servent aux données qui ne passent PAS par elle — les résultats du moteur
// de recherche — et à neutraliser les formulaires d'édition, pour qu'une
// valeur masquée ne soit jamais réenregistrée par-dessus la vraie.

export const MASKED_TEXT = '•••';

// INTERRUPTEUR — masquage du téléphone.
//
// Désactivé pour l'instant : le staff a besoin du numéro réel pour appeler le
// client, et il n'existe pas encore de numéro virtuel pour s'intercaler. À
// remettre à true le jour où ces numéros arrivent.
//
// Miroir de `MASK_PHONE_NUMBERS` dans
// `DeleevCore/accounts/libs/customer_pii.py` : les deux basculent ensemble.
// Tant qu'il est à false l'api renvoie le numéro en clair, donc le laisser à
// true ici n'afficherait que des points par-dessus une donnée disponible.
export const MASK_PHONE_NUMBERS = false;

export const maskPhone = (value) => {
  if (!MASK_PHONE_NUMBERS) return value;
  return value ? MASKED_TEXT : value;
};

// « Julien », « Nguyen » -> « Julien N. »
export const maskName = (firstName, lastName) => {
  const first = (firstName || '').trim();
  const last = (lastName || '').trim();
  const initial = last ? `${last[0].toUpperCase()}.` : '';
  return [first, initial].filter(Boolean).join(' ');
};

// « Julien Nguyen » (nom déjà concaténé, cas du moteur de recherche)
export const maskFullName = (fullName) => {
  const parts = (fullName || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length <= 1) return parts.join(' ');
  return maskName(parts.slice(0, -1).join(' '), parts[parts.length - 1]);
};

// Repli d'une adresse déjà mise en forme : son code postal (+ ville si elle y
// est). Même règle que le back (`mask_address_string`) : le format est
// « <numéro> <rue>, <code postal>[ <ville>] », on garde ce qui suit la
// dernière virgule — une rue peut en contenir une. Sans virgule, on ne sait
// pas isoler le code postal, donc on masque tout.
export const maskAddress = (value) => {
  const text = (value || '').trim();
  if (!text) return text;
  const cut = text.lastIndexOf(',');
  if (cut === -1) return MASKED_TEXT;
  return text.slice(cut + 1).trim() || MASKED_TEXT;
};
